import { SET_USER } from '../constants/ActionTypes';

export default function setUser(user) {
    return async (dispatch) => {
        return dispatch({ type: SET_USER, body: user });
    };
}
